module.exports = __webpack_public_path__ + "static/media/2.139b3174.png";